import React, { useState, useEffect } from 'react'; // <-- 1. Add useEffect to the import
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// import { MessageCircle } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import { WishlistProvider } from './context/WishlistContext';
import { SiteConfigProvider, useSiteConfig } from './context/SiteConfigContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProductModal from './components/ProductModal';
import CartDrawer from './components/CartDrawer';
import SearchOverlay from './components/SearchOverlay';
import Home from './pages/Home';
import Collection from './pages/Collection';
import Product from './pages/Product';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import Forgot from './pages/Forgot';
import Account from './pages/Account';
import Contact from './pages/Contact';
import Page from './pages/Page';
import VerifyOtp from './pages/VerifyOtp'; 
import { FaWhatsapp } from "react-icons/fa";

function WhatsAppFloat() {
  const { config } = useSiteConfig();

  if (!config?.whatsapp) return null;

  return (
    <a
      href={`https://wa.me/${config.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-5 z-30 bg-[#25D366] hover:bg-[#1ebe57] text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center"
      aria-label="WhatsApp"
    >
      <FaWhatsapp size={30} />
    </a>
  );
}

function AnimatedRoutes({ setModalProduct, handleAddToCart, cart, setCart }) {
  const location = useLocation();

  // <-- 2. Add this useEffect block right here!
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home onOpen={setModalProduct} />} />
          <Route path="/collection/:slug" element={<Collection onOpen={setModalProduct} />} />
          <Route path="/product/:id" element={<Product onAddToCart={handleAddToCart} cart={cart} />} />
          <Route path="/checkout" element={<Checkout cart={cart} onClearCart={() => setCart([])} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pages/:slug" element={<Page />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/account/*" element={<Account onOpen={handleAddToCart} />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  const [modalProduct, setModalProduct] = useState(null);
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const handleAddToCart = (p) => {
    setCart(prev => {
      const idx = prev.findIndex(x => x.id === p.id && x.size === p.size);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: (copy[idx].qty || 1) + 1 };
        return copy;
      }
      return [...prev, { ...p, qty: 1 }];
    });
    setModalProduct(null);
    setCartOpen(true);
  };

  const handleUpdateQty = (i, qty) => setCart(prev => prev.map((x, k) => k === i ? { ...x, qty } : x));
  const handleRemove = (i) => setCart(prev => prev.filter((_, k) => k !== i));
  const cartCount = cart.reduce((s, i) => s + (i.qty || 1), 0);

  return (
    <div className="App font-sans">
      <SiteConfigProvider>
        <AuthProvider>
          <WishlistProvider>
            <BrowserRouter>
              <Navbar cartCount={cartCount} onOpenCart={() => setCartOpen(true)} onOpenSearch={() => setSearchOpen(true)} />
              <AnimatedRoutes
                setModalProduct={setModalProduct}
                handleAddToCart={handleAddToCart}
                cart={cart}
                setCart={setCart}
              />
              <Footer />

              {modalProduct && (
                <ProductModal
                  product={modalProduct}
                  onClose={() => setModalProduct(null)}
                  onAddToCart={handleAddToCart}
                />
              )}

              <CartDrawer
                open={cartOpen}
                onClose={() => setCartOpen(false)}
                items={cart}
                onUpdate={handleUpdateQty}
                onRemove={handleRemove}
              />

              <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
              <WhatsAppFloat />
            </BrowserRouter>
          </WishlistProvider>
        </AuthProvider>
      </SiteConfigProvider>
    </div>
  );
}

export default App;